import { gql, type TypedDocumentNode } from "@apollo/client";
import type { UpsertCareerIntentInput } from "./career-profile/careerIntentForm";

export type UpsertCareerIntentResponse = {
  upsertCareerIntent: {
    success: boolean;
    message: string | null;
  };
};

export type UpsertCareerIntentVariables = {
  input: UpsertCareerIntentInput;
};

export const UPSERT_CAREER_INTENT_MUTATION: TypedDocumentNode<UpsertCareerIntentResponse, UpsertCareerIntentVariables> =
  gql`
    mutation UpsertCareerIntent($input: BackofficeUpsertCareerIntentInput!) {
      upsertCareerIntent(input: $input) {
        success
        message
      }
    }
  `;
